import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult, WrappedItemsResult } from './types';

const consortiumsApi = {
  getAll(
    params?: cyrian.api.consortiums.GetParams,
  ): ApiResponse<WrappedItemsResult<cyrian.api.consortiums.Consortium[]>> {
    return request({
      method: 'get',
      url: '/consortiums',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.consortiums.Consortium>> {
    return request({
      method: 'get',
      url: `/consortiums/${id}`,
    });
  },
  create(
    data: cyrian.api.consortiums.ConsortiumCreateParams,
  ): ApiResponse<WrappedResult<cyrian.api.consortiums.Consortium>> {
    return request({
      method: 'post',
      url: '/consortiums',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.consortiums.ConsortiumUpdateParams,
  ): ApiResponse<WrappedResult<cyrian.api.consortiums.Consortium>> {
    return request({
      method: 'patch',
      url: `/consortiums/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<void>> {
    return request({
      method: 'delete',
      url: `/consortiums/${id}`,
    });
  },
};

export default consortiumsApi;
